import type { ReactNode } from 'react';
import React from 'react';

import type { CallHistoryItem } from './CallHistoryDropdown';

// Helper to safely parse and clean the content from the two-column label
export const getLabelParts = (
  item: CallHistoryItem | undefined
): [ReactNode, ReactNode] => {
  if (!item) {
    return [null, null];
  }

  if (!React.isValidElement(item.label)) {
    return [item.label, null];
  }

  try {
    const children = React.Children.toArray(item.label.props.children);
    if (children.length < 2) {
      return [item.label, null];
    }

    const [numberEl, timeEl] = children as React.ReactElement[];

    const extractContent = (element: React.ReactElement): ReactNode => {
      const content = element?.props?.children;
      return typeof content === 'string' ? content.trim() : content;
    };

    return [extractContent(numberEl), extractContent(timeEl)];
  } catch (error) {
    console.error('CallHistoryDropdown: Error parsing label:', error);
    return [item.label, null];
  }
};

// Helper for consistent ID comparison
export const compareIds = (
  id1: string | number | null | undefined,
  id2: string | number | null | undefined
): boolean => {
  if (id1 == null || id2 == null) {
    // Any nullish value compared to any other nullish value is false
    return false;
  }
  return String(id1) === String(id2);
};
